export default "__VITE_ASSET__Bg7MnfNE__"